
import { useEffect, useState } from "react";
import { _QualityInspectionSample, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from "../../../../../theme/Component/hooks/useModal";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { BasicTable, MASK_BOOLEAN, MASK_BOOLEAN_ICON, MASK_TEXT_NOWRAP } from "../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { ListSamplesInspections } from "./ListSamplesInspections";
import usePaginator from "../../../../../theme/Component/usePaginator";
import { ListSamplesCotaInspections } from "./ListSamplesCotaInspections";

interface componentData {
    QualityInspectionProdcutRamdom: any
}

export const QualityInspectionSample = ({ QualityInspectionProdcutRamdom }: componentData) => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_QualityInspectionSample)
    const paginator = usePaginator();

    const modal = useModal("", MODAL_md);
    const modalC = useModal("Eliminar Inspección", MODAL_SM);
    const modalCota = useModal("Cota/Requisitos", MODAL_LG);
    const modalFinish = useModal("Acabados", MODAL_LG);

    const head = [
        { title: 'ID', property: 'IDQualityInspectionSample', visible: true },
        { title: 'Muestras', property: 'SampleName', visible: true },
        { title: 'Presenta Cotas', property: 'RenderList', visible: true, Style: { width: "280px"} },
        { title: 'Presenta Acabados', property: 'RenderListFF', visible: true, Style: { width: "280px" } },
        { title: 'Usuario que Registra', property: 'UserEntity', visible: true, mask: MASK_TEXT_NOWRAP },
    ];

    useEffect(() => {
        if (QualityInspectionProdcutRamdom?.IDQualityInspectionProductRamdom) {
            getLista();
        }
    }, [QualityInspectionProdcutRamdom?.IDQualityInspectionProductRamdom, paginator.page])

    const renderGarments = (garments: any[]) => {
        if (!garments || garments.length === 0) return "N/P";

        const render = garments.map((medida, index) => {
            return `
            <div key="${index}">
                <strong>${medida.Name} - ${medida.Satisfy ? "Cumple" : "No Cumple"}</strong>
            </div>
        `;
        });
        return render.join("");
    };

    const getLista = () => {
        const props = {
            IDQualityInspectionProductRamdom: QualityInspectionProdcutRamdom?.IDQualityInspectionProductRamdom,
            State: 1
        }
        instance.getQualityInspectionSampleRender(paginator.page, 15, props).then(
            (resp) => {
                paginator.setPages(resp.NumberOfPages);
                paginator.setRecords(resp.NumberOfPages * 15);
                resp.List.forEach(element => {
                    const data = element.DataBeanProperties;

                    data.UserEntity = data.IDEmployee ? `${data.EmployeeNit} - ${data.EmployeeFullName}` : "N/A";

                    let cotas = [];
                    let ff = [];

                    if (data.JSONCota) {
                        try {
                            cotas = JSON.parse(data.JSONCota);
                        } catch (err) {
                            console.error("Error parseando JSONCota:", err);
                        }
                    }
                    if (data.JSONFabricFinish) {
                        try {
                            ff = JSON.parse(data.JSONFabricFinish);
                        } catch (err) {
                            console.error("Error parseando FabricFinish:", err);
                        }
                    }

                    data.RenderList = renderGarments(cotas);
                    data.RenderListFF = renderGarments(ff);

                });
                setLista(resp.List)
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const deleteItem = () => {
        let x = { ...bean, State: 2 };
        editaItem(x);
    };

    const create = () => {
        setBean({
            IDQualityInspectionProductRamdom: QualityInspectionProdcutRamdom?.IDQualityInspectionProductRamdom,
            State: 1,
            IDEmployee: _single.getAccountID(),
            SampleName: ""
        });
        modal.open("Agregar Norma o Especificación");
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { modal.open("Editar Norma o Especificación") } },
            { titulo: 'Cota/Requisitos', icono: 'ri-list-check', visible: true, evento: () => { modalCota.open() } },
            { titulo: 'Acabados', icono: 'ri-list-check', visible: true, evento: () => { modalFinish.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { modalC.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const editaItem = (obj: any) => {
        instance.updateQualityInspectionSample(obj).then(
            (resp: any) => {
                getLista();
                modal.close();
                modalC.close();
                modalCota.close();
                modalFinish.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const validateForm = () => {
        const requiredFields = [
            "SampleName"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    iconButtons={iconButtonsItem}
                    listButtons={listaBotones()}
                    pageTop={paginator.page}
                    next={paginator.next}
                    back={paginator.back}
                    records={paginator}
                />
            </div>

            <div className="col-md-12">
                <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => { validateData() }} >
                    <div className="row">
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('SampleName') ? 'has-error' : ''}`} >Consecutivo de Prenda</label>
                            <input type="text" className="form-control" value={bean.SampleName} onChange={(e) => { setBean({ ...bean, SampleName: e.target.value }) }} />
                        </div>
                    </div>
                </Modal>

                <Modal modal={modalCota.modal} updateModal={modalCota.setModal} eventModal={() => { editaItem(bean) }} onSubmitLabel="Guardar Cambios" >
                    <ListSamplesCotaInspections jsonProps={bean.JSONCota} onChange={(e) => { setBean({ ...bean, JSONCota: e }) }} labelSelector="Cota/Requisito" />
                </Modal>

                <Modal modal={modalFinish.modal} updateModal={modalFinish.setModal} eventModal={() => { editaItem(bean) }} onSubmitLabel="Guardar Cambios">
                    <ListSamplesInspections jsonProps={bean.JSONFabricFinish} onChange={(e) => { setBean({ ...bean, JSONFabricFinish: e }) }} labelSelector="Acabado" CodeSelector={910} />
                </Modal>

                <ModalConfirm eventModal={() => { deleteItem() }} updateModal={modalC.setModal} modal={modalC.modal} >
                    <strong>¿Desea Continuar con la accion?</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}